import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';

import { GalleryRepresentation as GalleryRepresentationType } from '@definitions/galleries.types';
import { GalleryAddressBlock } from '@components/galleryAddressBlock';

import { Container, Title, Content } from './galleryRepresentation.styles';
import { GALLERY_REPRESENTATION_TEST_ID } from './galleryRepresentation.constants';

export interface GalleryRepresentationProps {
  galleries: GalleryRepresentationType[];
}

export const GalleryRepresentation = ({ galleries }: GalleryRepresentationProps) => {
  const intl = useIntl();

  return (
    <Container data-testid={GALLERY_REPRESENTATION_TEST_ID}>
      <Fragment>
        <Title>
          <span> {intl.formatMessage({ id: 'artworkView.representedByTitle', defaultMessage: 'OFFERED BY' })}</span>
        </Title>
        <Content>
          {galleries.map(({ id, value }: GalleryRepresentationType) => (
            <GalleryAddressBlock key={id} {...value} />
          ))}
        </Content>
      </Fragment>
    </Container>
  );
};
